import { Icon } from "@common/index";

interface CheckoutStepsProps {
    /** 1 = Cart, 2 = Checkout, 3 = Confirmation. */
    current: number;
}

const STEPS = [
    { n: 1, label: "Cart" },
    { n: 2, label: "Checkout" },
    { n: 3, label: "Confirmation" },
] as const;

export const CheckoutSteps = ({ current }: CheckoutStepsProps) => {
    return (
        <ol
            className="flex items-center w-full"
            aria-label="Checkout progress"
            data-testid="checkout-steps"
        >
            {STEPS.map((step, index) => {
                const isComplete = step.n < current;
                const isActive = step.n === current;
                const status = isComplete
                    ? "complete"
                    : isActive
                        ? "active"
                        : "upcoming";

                return (
                    <li
                        key={step.n}
                        className={`flex items-center ${
                            index < STEPS.length - 1 ? "flex-1" : ""
                        }`}
                        aria-current={isActive ? "step" : undefined}
                        data-status={status}
                    >
                        <div className="flex items-center gap-2 shrink-0">
                            <span
                                className={[
                                    "flex items-center justify-center w-8 h-8 rounded-full text-sm font-bold",
                                    isComplete
                                        ? "bg-success text-success-content"
                                        : isActive
                                            ? "bg-neutral text-neutral-content"
                                            : "bg-base-300 text-neutral/50",
                                ].join(" ")}
                            >
                                {isComplete ? (
                                    <Icon name="check" className="text-lg" />
                                ) : (
                                    step.n
                                )}
                            </span>
                            <span
                                className={`text-sm font-semibold ${
                                    isActive || isComplete
                                        ? "text-neutral"
                                        : "text-neutral/50"
                                }`}
                            >
                                {step.label}
                            </span>
                        </div>
                        {index < STEPS.length - 1 && (
                            <span
                                className={`flex-1 h-0.5 mx-3 ${
                                    isComplete ? "bg-success" : "bg-base-300"
                                }`}
                            />
                        )}
                    </li>
                );
            })}
        </ol>
    );
};
